// 9fbef606107a605d69c0edbcd8029e5d
const green = {
  250: '#eaffdb',
  300: '#7dc24c',
  400: '#4b742d',
  500: '#26762c',
  550: '#26762d',
  600: '#19711f',
  200: '#d8edca',
  700: '#3c7f2e',
  800: '#327f86',
  900: '#70B043',
  1000: '#3d9c24',
};

export default green;
